module.exports = __webpack_public_path__ + "img/01.7cfa91c9.jpg";